// extracted by mini-css-extract-plugin
export default {"itemRtl":"wecVZ6qJ"};